export function filterPasswordStrengthText(value){
  return ['None','very weak','weak','average','strong','very strong'][value] || ''
}